<template>
  <div class="grid gap-4">
    <course-program-download-cta
      block
      :course="course"
      origin="course"
      :size="size"
    />

    <growth-contact-button
      block
      origin="course"
      origin_page_action="enrolment_intra_cta"
      :origin_page_id="course.slug"
      :size="size"
      variant="tonal"
    >
      Obtenir un devis
    </growth-contact-button>
  </div>
</template>

<script lang="ts" setup>
import type { ButtonSize } from "@pollen/ui-library";

import type { CoursePageView } from "~/business-areas/course/course.model";

defineProps<{
  course: CoursePageView;
  size?: ButtonSize;
}>();
</script>
